import styled from 'styled-components/native';

import Button from '@src/components/Button';
import { Body1 } from '@src/components/Typography';

export const TextButton = styled(Button).attrs(() => ({
  uppercase: false,
  mode: 'text',
  contentStyle: {
    alignItems: 'center',
    paddingStart: 30,
  },
}))``;

export const ButtonLabel = styled(Body1)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  padding-horizontal: 5px;
`;

export const InputContainer = styled.View`
  justify-content: space-around;
`;

export const BottomContainer = styled.View`
  justify-content: space-around;
`;

export const Container = styled.View`
  flex-grow: 1;
  justify-content: space-between;
`;

export const RTLContainer = styled(Container)`
  align-items: flex-start;
  margin-top: 40px;
`;
